module.exports = __webpack_public_path__ + "media/icons/naped-przod-white@3x-e863585e.svg";